export default function HeroSection() {
  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-slate-900 via-teal-900 to-slate-900">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
        backgroundSize: '50px 50px'
      }}></div>

      {/* Gradient Orbs */}
      <div className="absolute top-20 left-1/4 w-96 h-96 bg-teal-500/20 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-20 right-1/4 w-96 h-96 bg-cyan-500/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-32">
        <div className="inline-flex items-center px-6 py-3 bg-white/10 backdrop-blur-md rounded-full mb-8 border border-white/20">
          <i className="ri-shopping-cart-line text-teal-400 text-xl mr-3"></i>
          <span className="text-white text-sm font-bold">会社買収の手続き</span>
        </div>

        <h1 className="text-5xl md:text-7xl font-black text-white mb-8 leading-tight">
          会社を買収する際の
          <br />
          <span className="bg-gradient-to-r from-teal-400 to-cyan-400 bg-clip-text text-transparent">手続き・流れ</span>
        </h1>

        <p className="text-xl text-gray-300 mb-12 leading-relaxed max-w-3xl mx-auto">
          手続き完了まで、4週間を想定しております。<br />
          お急ぎの方は事前にご相談ください。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          <a
            href="/company-list"
            className="group px-10 py-5 bg-gradient-to-r from-teal-500 to-cyan-500 text-white rounded-full font-bold text-lg hover:shadow-2xl hover:shadow-teal-500/30 transition-all duration-300 flex items-center whitespace-nowrap cursor-pointer"
          >
            売り会社一覧を見る
            <i className="ri-arrow-right-line ml-3 group-hover:translate-x-1 transition-transform"></i>
          </a>
          <a
            href="mailto:info@nextage.jp"
            className="group px-10 py-5 bg-white/10 backdrop-blur-md text-white rounded-full font-bold text-lg hover:bg-white/20 transition-all duration-300 flex items-center whitespace-nowrap cursor-pointer border border-white/20"
          >
            お問い合わせ
            <i className="ri-mail-line ml-3"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
